module.exports = __webpack_public_path__ + "img/V26.09f353df.jpg";